
import InstitutionContactModalView from "./InstitutionContactModal.html";
import InstitutionAddressModalView from "./InstitutionAddressModal.html";
import InstitutionMailModalView from "./InstitutionMailModal.html";

import IconPicker from '../../../scripts/iconpicker-1.5.0.js';

angular.module("institutions")

    .controller("institutionsEditCtrl", ['LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', '$filter', '$translate', '$timeout', 'uiGridConstants', 'id_from_modal', 'logService',
        function (LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, $filter, $translate, $timeout, uiGridConstants, id_from_modal, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("PERSONS_WRITE");

        $scope.institution = { contacts: []};
        //Icon Picker, usamos angular.element para asegurar que el docuemnto se ha cargado antes de iniciar la función
        angular.element(function () {
            logService.debug('page loading completed');
            IconPicker.Init({
                // Required: You have to set the path of IconPicker JSON file to "jsonUrl" option. e.g. '/content/plugins/IconPicker/dist/iconpicker-1.5.0.json'
                jsonUrl: '/assets/iconpicker-1.5.0.json',
                // Optional: Change the buttons or search placeholder text according to the language.
                searchPlaceholder: 'Search Icon',
                showAllButton: 'Show All',
                cancelButton: 'Cancel',
                noResultsFound: 'No results found.', // v1.5.0 and the next versions
                borderRadius: '20px', // v1.5.0 and the next versions
            });

            IconPicker.Run('#GetIconPicker', function () {
                // ng-bind no funciona para asignar el icono porque no detecta el cambio que hacemos con el IconPicker, así que hay que hacerlo a pelo.
                const iconElement = document.querySelector("#IconPreview");
                if (iconElement) {
                    const iconClass = iconElement.getAttribute("class");
                    if (iconClass) {
                        const icon = iconClass.substring(iconClass.indexOf('-') + 1);
                        $scope.institution.icon = icon;
                    }
                }
            });
        });

        if (id_from_modal == false)
            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('institutions.title'), url: `institutions.list`},
                    { title: $filter('translate')('general.add') },
                ];
            } else {
                $rootScope.breadcrumb = [
                    { title: $filter('translate')('institutions.title'), url: `institutions.list`},
                    { title: $filter('translate')('general.edit') },
                ];
                Restangular.one('Institutions', $stateParams.id).get().then(function (result) {
                    $scope.institution = result;
                    logService.debug($scope.institution)
                });
            }

        if (id_from_modal)
            Restangular.one('Institutions', id_from_modal).get().then(function (result) {
                $scope.institution = result;
                logService.debug($scope.institution)
            });

        $scope.gridContact = {
            pdfTitle: $filter('translate')('persons.contact_data'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;

            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'contacts_types.name', displayName: $filter('translate')('persons.contact_type'),
                },
                {
                    name: 'value', displayName: $filter('translate')('persons.value'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: 'notes', displayName: $filter('translate')('persons.notes'), enableFiltering: true, enableHiding: false,
                },
                {
                    name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ng-click ="grid.appScope.editContact(row.entity)" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="grid.appScope.deleteContact(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {
                return new Promise(function (resolve, reject) {
                    resolve($scope.institution.contacts);
                });
            }
        };

        $scope.gridAddress = {
            pdfTitle: $filter('translate')('persons.addresses'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            rowHeight: 45,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [10, 20, 30],
            paginationPageSize: 10,
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, exporterSuppressExport: true },
                {
                    name: 'address_line_1', displayName: $filter('translate')('persons.address_line_1'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,
                    cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.address_line_1}}<br/> {{row.entity.postal_code}}, {{row.entity.city}} </div>',
                },
                { name: 'state', displayName: $filter('translate')('persons.contact_state'), width: 150 },
                { name: 'city', displayName: $filter('translate')('persons.contact_city'), width: 150 },
                { name: 'notes', displayName: $filter('translate')('persons.notes'), visible: true },
                {
                    name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.edit'), action: 'ng-click="grid.appScope.editAddress(row.entity)" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.delete'), action: 'ng-click="$event.stopPropagation();grid.appScope.deleteAddress(row.entity);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {
                return new Promise(function (resolve, reject) {
                    resolve($scope.institution.addresses);
                });
            }
        };

        $scope.editContact = function (contact) {
            contact ? $scope.newContact = contact : $scope.newContact = {};

            $scope.$modalInstance = $uibModal.open({
                animation: true,
                template: InstitutionContactModalView,
                controller: "InstitutionContactModalCtrl",
                resolve: {},
                scope: $scope,
                size: 'lg'
            });
        };

        $scope.editAddress = function (address) {
            address ? $scope.newAddress = address : $scope.newAddress = {};

            $scope.$modalInstance = $uibModal.open({
                animation: true,
                template: InstitutionAddressModalView,
                controller: "InstitutionAddressModalCtrl",
                resolve: {},
                scope: $scope,
                size: 'lg'
            });
        };

        $scope.editMail = function (mail) {

            mail ? $scope.newMail = mail : $scope.newMail = {};
            logService.debug("this is the mail")
            logService.debug(mail);

            $scope.$modalInstance = $uibModal.open({
                animation: true,
                template: InstitutionMailModalView,
                controller: "InstitutionMailModalCtrl",
                resolve: {},
                scope: $scope,
                size: 'lg'

            });
        };

        $scope.deleteContact = function (contact) {
            logService.debug("item")
            logService.debug(contact)
            logService.debug("array")
            logService.debug($scope.institution.contacts)
            let index = $scope.institution.contacts.indexOf(contact);
            logService.debug(index)

            $scope.institution.contacts.splice(index, 1);
        };

        $scope.deleteAddress = function (address) {
            let index = $scope.institution.addresses.indexOf(address)
            logService.debug(index)
            $scope.institution.addresses.splice(index, 1);
        };


        $scope.deleteMails = function (mail) {
            logService.debug(mail);
            let index = $scope.institution.mails.indexOf(mail)
            logService.debug(index)
            $scope.institution.mails.splice(index, 1);
        };

        $scope.save = function () {
            if (!angular.isUndefined($scope.institution.id)) {
                $scope.institution.put().then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('institutions.modified_success'));
                        // $state.go('institutions.list');
                        $scope.institution.id = result.id;
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            } else {
                Restangular.all('Institutions').post($scope.institution).then(function (result) {
                    if (typeof (result.id) != "undefined") {
                        toastr.success($filter('translate')('institutions.created_success'));
                        // $state.go('institutions.list');
                        $scope.institution.id = result.id;
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }

        $scope.checkDelete = function () {
            modalService.confirm({
                title: $filter('translate')('general.delete'),
                message: $filter('translate')('institutions.delete_message'),
                onAccept: function () {
                    $scope.institution.remove().then(function () {
                        toastr.success($filter('translate')('institutions.remove_success'));
                        $state.go('institutions.list');
                    });
                }
            });
        };

        // Gestión de modal 
        $scope.onCancelInstitution = function () {
            $scope.$modalInstance.dismiss('cancel');
        };

        $scope.onAcceptInstitution = function () {
            $scope.institution.put().then(function (results) {
                if (typeof (results.id) != "undefined") {
                    toastr.success($filter('translate')('institutions.modified_success'));
                } else
                    $scope.errorMessage = results.message;
            })
            $scope.$modalInstance.close();
        }


    }])
    .controller("InstitutionContactModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter', 'Restangular', 'logService',
        function ($scope, $uibModalInstance, modalService, $filter, Restangular, logService) {

        Restangular.all('ContactsTypes').getList().then(results => $scope.contactTypesSelect = results )

        $scope.ContactTitle = $scope.newContact.id ? ($filter('translate')('general.edit')) : ($filter('translate')('general.add'));

        $scope.onCancel = function () {
            $scope.newContact = {};
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onSelect = function (typeName) {
            logService.debug("dsadsad asda")
            $scope.newContact.contact_types.name = typeName;
        };

        $scope.onAccept = function () {
            $scope.newContact.contact_type_id = $scope.newContact.contacts_types.id;
            if (!$scope.institution.contacts.includes($scope.newContact)) $scope.institution.contacts.push($scope.newContact);
            $scope.gridContact.loadData();
            $scope.newContact = {};
            $uibModalInstance.close();
        };

    }])
    .controller("InstitutionAddressModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter', 'Restangular', function ($scope, $uibModalInstance, modalService, $filter, Restangular) {

        $scope.addressTitle = $scope.newAddress.id ? ($filter('translate')('general.edit')) : ($filter('translate')('general.add'));

        Restangular.all('Countries').getList().then(results => $scope.countryList = results);

        $scope.onCancel = function () {
            $scope.newAddress = {};
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            if (!$scope.institution.addresses.includes($scope.newAddress)) {
                $scope.institution.addresses.push($scope.newAddress);
            }
            $scope.gridAddress.loadData();
            $scope.newAddress = {};
            $uibModalInstance.close();
        };

    }])
    .controller("InstitutionMailModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter', 'Restangular', function ($scope, $uibModalInstance, modalService, $filter, Restangular) {

        $scope.mailTitle = $scope.newMail.id ? ($filter('translate')('general.edit')) : ($filter('translate')('general.add'));

        $scope.onCancel = function () {
            $scope.newMail = {};
            $uibModalInstance.dismiss('cancel');
        };

        $scope.onAccept = function () {
            if (!$scope.institution.mails.includes($scope.newMail)) {
                $scope.institution.mails.push($scope.newMail);
            }   
            $scope.newMail = {};
            $uibModalInstance.close();
        };

        $scope.onDelete = function () {
            $scope.deleteMails($scope.newMail);
            $scope.newMail = {};
            $uibModalInstance.close();
        }
    }])

    /*
    .controller("InstitutionPreviewModalCtrl", ['$scope', '$uibModalInstance', 'modalService', '$filter', 'Restangular', 'institutionMails', 'institutionAddresses', 'institutionContacts','gridService',
        function ($scope, $uibModalInstance, modalService, $filter, Restangular, institutionMails, institutionAddresses, institutionContacts, gridService) {

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
            $scope.onImport = function () {
                mailsToImport = $scope.institutionMails.filter(m => m.selected);
                mailsToImport.forEach(function (mail) {
                    mail.position_id = $scope.position.id;
                    mail.id = 0;

                    if (!$scope.position.FK_positions_mails_positions.includes(mail))
                    Restangular.all('PositionsMails').post(mail);
                });

                contactsToImport = institutionContacts.filter(c => c.selected);

                contactsToImport.forEach(function (contact) {
                    contact.position_id = $scope.position.id;
                    contact.position_contact_type_id = contact.contact_type_id;
                    contact.FK_positions_contacts_positions_contacts_types = contact.contacts_types;
                    contact.position_contact_scope_id = 2;
                    contact.id = 0;
                    contact.isNew = true;
                    if (!$scope.position.FK_positions_contacts_positions.includes(contact))
                        $scope.position.FK_positions_contacts_positions.push(contact);
                });

                addressesToImport = institutionAddresses.filter(a => a.selected);

                addressesToImport.forEach(function (address) {
                    address.position_address_scope_id = 2;
                    address.position_id = $scope.position.id;
                    address.person_position_id = $scope.position.id;
                    address.id = 0;
                    if (!$scope.position.FK_positions_addresses_positions.includes(address))
                       $scope.position.FK_positions_addresses_positions.push(address);
                });

            $scope.reloadPositionsEmails();
                toastr.success($filter('translate')('institutions.imported_data_succes'));
            logService.debug($scope.position)
            $uibModalInstance.close();
        };

        $scope.onDelete = function () {
            $scope.deleteMails(newMail);
            $scope.newMail = {};
            $uibModalInstance.close();
            }

            $scope.institutionMails = institutionMails.map(mail => mail = {...mail, selected: true  });

            $scope.gridContactPreview = {
                pdfTitle: $filter('translate')('persons.contact_data'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;

                },
                columnDefs: [
                    {
                        name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate:
                            '<div class="ui-grid-cell-contents"><input type="checkbox" value="true" ng-model="row.entity.selected" /></div>'
                    },
                    { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                    {
                        name: 'contacts_types.name', displayName: $filter('translate')('persons.contact_type'),
                    },
                    {
                        name: 'value', displayName: $filter('translate')('persons.value'), enableFiltering: true, enableHiding: false,
                    },
                    {
                        name: 'notes', displayName: $filter('translate')('persons.notes'), enableFiltering: true, enableHiding: false,
                    }
                ],
                getData: function (options) {
                   return  new Promise(function (resolve, reject) {
                        resolve(institutionContacts)
                    }).then(function (results) {
                            results.forEach(r => r.selected = true);
                            return results;
                    })
                }
            };

            $scope.gridAddressPreview = {
                pdfTitle: $filter('translate')('persons.addresses'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                rowHeight: 45,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    {
                        name: ' ', width: 50, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate:
                            '<div class="ui-grid-cell-contents"><input type="checkbox" value="true" ng-model="row.entity.selected" /></div>'
                    },
                    { name: 'id', visible: false, exporterSuppressExport: true },
                    {
                        name: 'address_line_1', displayName: $filter('translate')('persons.address_line_1'), enableColumnMenu: false, enableFiltering: false, enableHiding: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.address_line_1}}<br/> {{row.entity.postal_code}}, {{row.entity.city}} </div>',
                    },
                    { name: 'state', displayName: $filter('translate')('persons.contact_state'), width: 150 },
                    { name: 'city', displayName: $filter('translate')('persons.contact_city'), width: 150 },
                    { name: 'notes', displayName: $filter('translate')('persons.notes'), visible: true },

                ],
                getData: function (options) {
                    return new Promise(function (resolve, reject) {
                        resolve(institutionAddresses);
                    }).then(function (results) {
                        results.forEach(r => r.selected = true);
                        return results;
                    });
                }
            };


        $scope.deleteContact = function (contact) {
            index = positionContacts.indexOf(contact)
            logService.debug(index)

            positionContacts.splice(index, 1);
        };

        $scope.deleteAddress = function (address) {
            index = positionAddresses.indexOf(address)
            logService.debug(index)
            positionAddresses.splice(index, 1);
        };


        $scope.deleteMails = function (mail) {
            index = positionMails.indexOf(mail)
            logService.debug(index)

            $scope.institution.mails.splice(index, 1);
            };

    }]);

*/